import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: false };
  }
  static getDerivedStateFromError() {
    return { error: true };
  }
  componentDidCatch(error, info) {
    console.error("UI error:", error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-night px-6 text-center text-white">
          <p className="font-display text-3xl font-extrabold">Something went wrong</p>
          <p className="text-white/60">Please refresh the page. If the issue persists, contact info@fnni.in.</p>
          <button
            data-testid="error-reload-btn"
            onClick={() => window.location.reload()}
            className="rounded-full bg-teal-600 px-6 py-3 font-mono text-xs font-semibold uppercase tracking-[0.18em] text-white"
          >
            Refresh
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
